import { Component, inject } from '@angular/core';
import { ApiBaseService } from '../../../../../../projects/vendors/src/public-api';

@Component({
    selector: 'app-raw-material-status',
    templateUrl: './raw-material-status.component.html',
    styleUrl: './raw-material-status.component.scss',
    standalone: false
})
export class RawMaterialStatusComponent {

  rawMaterialStatus = [] as any[];
  apiBaseService = inject(ApiBaseService);

  ngOnInit(): void {
    this.getData();
  }

  private getData() {
    // this.apiBaseService.GET<any[]>([ApiEnum.SupplierModule,ApiEnum.Supplier])
    //   .subscribe({
    //     next: response => {
    //       this.heightSelling = response;

    //     }
    //   })
  }
}
